
<div class="text-center" style="padding: 25px 0px">
  <img *ngIf="ShowImage" src="" style="width:20%; " />
  <div class="font-not-available">
    {{Message}}
  </div>
</div>
